<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-12
        h4.card-title.mb-0
          | Video call
        div.small.text-muted
          |  Connect video calling with client
    br
    //- division for video call
    div(class="video-window", :class='{fullscreen: screenFull}')
      video(class="friendVideoCalling", :class='{fullscreen: screenFull}' id="friendsVideo" autoplay playsinline)
      video(class="yourVideoCalling", :class='{fullscreen: screenFull}' id="yourVideo" autoplay playsinline)
      br
      //- button(v-on:click="toggleFullscreen" type="button" class="full", :class='{fullscreen: screenFull}')
       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 28.361 28.361" style="enable-background:new 0 0 28.361 28.361;" xml:space="preserve" width="14px" height="14px">
        <g>
          <g id="c115_arrows">
          <path d="M28.36,19.595c0-0.868-0.665-1.57-1.491-1.57c-0.819,0.002-1.492,0.702-1.492,1.57v3.25l-6.018-6.021    c-0.582-0.583-1.524-0.583-2.106,0c-0.582,0.582-0.582,1.527,0,2.109l5.989,5.987h-3.235c-0.881,0.002-1.591,0.669-1.591,1.491    c0,0.824,0.71,1.49,1.591,1.49h6.761c0.881,0,1.59-0.665,1.593-1.49c-0.003-0.022-0.006-0.039-0.009-0.061    c0.003-0.028,0.009-0.058,0.009-0.087v-6.668H28.36z" fill="#000000"/>
          <path d="M9,16.824l-6.015,6.021v-3.25c0-0.868-0.672-1.568-1.493-1.57c-0.824,0-1.49,0.702-1.49,1.57L0,26.264    c0,0.029,0.008,0.059,0.01,0.087c-0.002,0.021-0.006,0.038-0.008,0.061c0.002,0.825,0.712,1.49,1.592,1.49h6.762    c0.879,0,1.59-0.666,1.59-1.49c0-0.822-0.711-1.489-1.59-1.491H5.121l5.989-5.987c0.58-0.582,0.58-1.527,0-2.109    C10.527,16.241,9.584,16.241,9,16.824z" fill="#000000"/>
          <path d="M19.359,11.535l6.018-6.017v3.25c0,0.865,0.673,1.565,1.492,1.568c0.826,0,1.491-0.703,1.491-1.568V2.097    c0-0.029-0.006-0.059-0.009-0.085c0.003-0.021,0.006-0.041,0.009-0.062c-0.003-0.826-0.712-1.491-1.592-1.491h-6.761    c-0.881,0-1.591,0.665-1.591,1.491c0,0.821,0.71,1.49,1.591,1.492h3.235l-5.989,5.987c-0.582,0.581-0.582,1.524,0,2.105    C17.835,12.12,18.777,12.12,19.359,11.535z" fill="#000000"/>
          <path d="M5.121,3.442h3.234c0.879-0.002,1.59-0.671,1.59-1.492c0-0.826-0.711-1.491-1.59-1.491H1.594    c-0.88,0-1.59,0.665-1.592,1.491C0.004,1.971,0.008,1.991,0.01,2.012C0.008,2.038,0,2.067,0,2.097l0.002,6.672    c0,0.865,0.666,1.568,1.49,1.568c0.821-0.003,1.493-0.703,1.493-1.568v-3.25L9,11.535c0.584,0.585,1.527,0.585,2.11,0    c0.58-0.581,0.58-1.524,0-2.105L5.121,3.442z" fill="#000000"/>
          </g>
            <g id="Capa_1_253_">
            </g>
          </g>
        </svg>
      button(id="alertClient" v-on:click="showFriendsFace" type="button" class="btn btn-primary btn-lg", :class='{fullscreen: screenFull}' style='display: none')
        span(class="glyphicon glyphicon-facetime-video" aria-hidden="true")
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="iconVideo" x="0px" y="0px" width="14px" height="14px" viewBox="0 0 348.077 348.077" style="enable-background:new 0 0 348.077 348.077;" xml:space="preserve">
          <g>
            <g>
              <g>
                <path d="M340.273,275.083l-53.755-53.761c-10.707-10.664-28.438-10.34-39.518,0.744l-27.082,27.076     c-1.711-0.943-3.482-1.928-5.344-2.973c-17.102-9.476-40.509-22.464-65.14-47.113c-24.704-24.701-37.704-48.144-47.209-65.257     c-1.003-1.813-1.964-3.561-2.913-5.221l18.176-18.149l8.936-8.947c11.097-11.1,11.403-28.826,0.721-39.521L73.39,8.194     C62.708-2.486,44.969-2.162,33.872,8.938l-15.15,15.237l0.414,0.411c-5.08,6.482-9.325,13.958-12.484,22.02     C3.74,54.28,1.927,61.603,1.098,68.941C-6,127.785,20.89,181.564,93.866,254.541c100.875,100.868,182.167,93.248,185.674,92.876     c7.638-0.913,14.958-2.738,22.397-5.627c7.992-3.122,15.463-7.361,21.941-12.43l0.331,0.294l15.348-15.029     C350.631,303.527,350.95,285.795,340.273,275.083z" fill="#FFFFFF"/>
              </g>
            </g>
          </g>
          </svg>
          | Call client
      button(id="alertStart" v-on:click="initializeVideocall" type="button" class="btn btn-primary btn-lg", :class='{fullscreen: screenFull}')
        span(class="glyphicon glyphicon-facetime-video" aria-hidden="true")
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="iconVideo" x="0px" y="0px" viewBox="0 0 41.76 41.76" style="enable-background:new 0 0 41.76 41.76;" xml:space="preserve" width="14px" height="14px">
                <g>
                  <path d="M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z" fill="#ffffff" stroke="#ffffff" stroke-width="3"/>
                  <path d="M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z" fill="#ffffff" stroke="#ffffff" stroke-width="3"/>
                </g>
                </svg>
          | Allow Camera
      button(id="closeVideoButton" v-on:click="closeVideo" type="button" class="btn btn-danger btn-lg", :class='{fullscreen: screenFull}' style='display: none')
        span(class="glyphicon glyphicon-facetime-video" aria-hidden="true")
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="iconVideo" x="0px" y="0px" viewBox="0 0 32.192 32.192" style="enable-background:new 0 0 32.192 32.192;" xml:space="preserve" width="14px" height="14px">
          <g>
            <path d="M0,17.783l0.02,2.637l0.003,0.004c0.006,0.603,0.498,1.033,1.047,1.027l0.007,0.004l7.489-0.06   c0.578-0.005,1.028-0.476,1.022-1.043l-0.021-2.64l-0.366,0.005c0.114-1.096,1.444-1.354,4.096-1.647l6.383-0.055   c1.534,0.149,3.022,0.425,3.129,1.617l-0.205,0.001l0.021,2.637l0.001,0.004c0.005,0.605,0.499,1.033,1.049,1.028l0.006,0.005   l7.488-0.062c0.579-0.002,1.027-0.474,1.023-1.041l-0.022-2.64l-0.271,0.002c-0.264-1.604-2.91-6.78-15.413-6.828   c-12.975-0.047-16.012,5.323-16.17,7.043L0,17.783z" fill="#FFFFFF"/>
          </g>
          </svg>
          | Hang Up
      button(id="muteMicButton" v-on:click="muteMic" type="button" class="btn btn-primary btn-lg", :class='{fullscreen: screenFull}' style='display: none')
        span(class="glyphicon glyphicon-facetime-video" aria-hidden="true" v-if="!micIsMute")
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="iconVideo" x="0px" y="0px" width="14px" height="14px" viewBox="0 0 461.55 461.55" style="enable-background:new 0 0 461.55 461.55;" xml:space="preserve">
          <g>
            <g id="volume-off">
              <path d="M345.525,229.5c0-45.9-25.5-84.15-63.75-102v56.1l63.75,63.75C345.525,239.7,345.525,234.6,345.525,229.5z M409.275,229.5    c0,22.95-5.1,45.9-12.75,66.3l38.25,38.25c17.85-30.6,25.5-68.85,25.5-107.1c0-109.65-76.5-201.45-178.5-224.4V56.1    C355.725,81.6,409.275,147.9,409.275,229.5z M34.425,0L1.275,33.15L121.125,153H1.275v153h102l127.5,127.5V262.65L340.425,372.3    c-17.851,12.75-35.7,22.95-58.65,30.601v53.55c35.7-7.65,66.3-22.95,94.35-45.9l51,51l33.15-33.149l-229.5-229.5L34.425,0z     M230.775,25.5l-53.55,53.55l53.55,53.55V25.5z" fill="#FFFFFF"/>
            </g>
          </g>
          </svg>
          | Mute Mic
        span(class="glyphicon glyphicon-facetime-video" aria-hidden="true" v-if="micIsMute")
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="iconVideo" x="0px" y="0px" width="14px" height="14px" viewBox="0 0 461.55 461.55" style="enable-background:new 0 0 461.55 461.55;" xml:space="preserve">
          <g>
            <g id="volume-off">
              <path d="M345.525,229.5c0-45.9-25.5-84.15-63.75-102v56.1l63.75,63.75C345.525,239.7,345.525,234.6,345.525,229.5z M409.275,229.5    c0,22.95-5.1,45.9-12.75,66.3l38.25,38.25c17.85-30.6,25.5-68.85,25.5-107.1c0-109.65-76.5-201.45-178.5-224.4V56.1    C355.725,81.6,409.275,147.9,409.275,229.5z M34.425,0L1.275,33.15L121.125,153H1.275v153h102l127.5,127.5V262.65L340.425,372.3    c-17.851,12.75-35.7,22.95-58.65,30.601v53.55c35.7-7.65,66.3-22.95,94.35-45.9l51,51l33.15-33.149l-229.5-229.5L34.425,0z     M230.775,25.5l-53.55,53.55l53.55,53.55V25.5z" fill="#FFFFFF"/>
            </g>
          </g>
          </svg>
          | Unmute Mic
      button(id="muteVideoButton" v-on:click="muteVideo" type="button" class="btn btn-primary btn-lg", :class='{fullscreen: screenFull}' style='display: none')
        span(class="glyphicon glyphicon-facetime-video" aria-hidden="true" v-if="!videoIsMute")
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 41.76 41.76" xml:space="preserve" width="14px" height="14px" class="iconVideo"><g><path d="M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z" fill="#ffffff" stroke="#ffffff" stroke-width="3"></path> <line x1="32" y1="35" x2="1" y2="5" style="fill: none; stroke: rgb(255, 255, 255); stroke-width: 3; stroke-linecap: round; stroke-miterlimit: 10;"></line> <path d="M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z" fill="#ffffff" stroke="#ffffff" stroke-width="3"></path></g></svg>
          | Mute Video 
        span(class="glyphicon glyphicon-facetime-video" aria-hidden="true" v-if="videoIsMute")
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 41.76 41.76" xml:space="preserve" width="14px" height="14px" class="iconVideo"><g><path d="M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z" fill="#ffffff" stroke="#ffffff" stroke-width="3"></path> <line x1="32" y1="35" x2="1" y2="5" style="fill: none; stroke: rgb(255, 255, 255); stroke-width: 3; stroke-linecap: round; stroke-miterlimit: 10;"></line> <path d="M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z" fill="#ffffff" stroke="#ffffff" stroke-width="3"></path></g></svg>
          | Unmute Video
      button(id="rejectCallButton" v-on:click="rejectCall" type="button" class="btn btn-danger btn-lg", :class='{fullscreen: screenFull}' style="display: none")
        span(class="glyphicon glyphicon-facetime-video" aria-hidden="true")
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="iconVideo" viewBox="0 0 21.9 21.9" enable-background="new 0 0 21.9 21.9" width="14px" height="14px">
            <path d="M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0  c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4  s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3  s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7  s-0.1-0.5-0.3-0.7L14.1,11.3z" fill="#FFFFFF"/>
          </svg>
          | Reject Call
      button(id="acceptCallButton" v-on:click="acceptCall" type="button" class="btn btn-success btn-lg", :class='{fullscreen: screenFull}' style="display: none")
        span(class="glyphicon glyphicon-facetime-video" aria-hidden="true")
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="iconVideo" viewBox="0 0 26 26" enable-background="new 0 0 26 26" width="14px" height="14px">
            <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z" fill="#FFFFFF"/>
          </svg>
          | Accept Call
     
    form
      b-form-textarea(id="textarea" v-model="noteText" placeholder="Take note.." :no-resize="true" :rows="4" :max-rows="16") 
      //- b-input-group
      //-   b-form-input(v-model='msg.content', :disabled='duplicateAgent')
      //-   b-input-group-button(slot='left', v-if='flagged')
      //-     b-button.btn(type='button', :variant='countdown < 10 ? "danger" : "success"', v-b-tooltip.hover='"Countdown"', disabled)
      //-       i.fa.fa-clock-o
      //-       | &nbsp;{{countdown}}
      //-   b-input-group-button(slot='right')
      //-     b-button.btn(v-if='!videoIsOn', type='button', variant='secondary', @click='initializeVideocall', v-b-tooltip.hover='"Start Video Call"', :disabled='duplicateAgent')
      //-       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="videoIcon" x="0px" y="0px" viewBox="0 0 41.76 41.76" style="enable-background:new 0 0 41.76 41.76;" xml:space="preserve" width="14px" height="14px">
      //-           <g>
      //-             <path d="M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z" fill="#ffffff" stroke="#ffffff" stroke-width="3"/>
      //-             <path d="M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z" fill="#ffffff" stroke="#ffffff" stroke-width="3"/>
      //-           </g>
      //-           </svg>
      //-     b-button.btn(v-if='videoIsOn', type='button', variant='success', @click='initializeVideocall', v-b-tooltip.hover='"Stop Video Call"', :disabled='duplicateAgent')
      //-       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="videoIcon" x="0px" y="0px" viewBox="0 0 41.76 41.76" style="enable-background:new 0 0 41.76 41.76;" xml:space="preserve" width="14px" height="14px">
      //-           <g>
      //-             <path d="M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z" fill="#ffffff" stroke="#ffffff" stroke-width="3"/>
      //-             <path d="M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z" fill="#ffffff" stroke="#ffffff" stroke-width="3"/>
      //-           </g>
      //-           </svg>
      //-     b-button.btn(type='button', variant='danger', v-if='!paused', @click='pause', v-b-tooltip.hover='"Pause Chatbot"', :disabled='duplicateAgent')
      //-       i.icon-control-pause
      //-     b-button.btn(type='button', variant='success', v-if='paused', @click='pause', v-b-tooltip.hover='"Unpause Chatbot"', :disabled='duplicateAgent')
      //-       i.icon-control-play
      //-     b-button.btn.text-white(type='submit', variant='secondary', @click='sendMessage', v-b-tooltip.hover='sending ? "Sending Message" : "Send Message"', :disabled='!msg.content || (flagged && duplicateAgent)')
      //-       i.fa.fa-refresh.fa-spin(v-if='sending')
      //-       i.icon-paper-plane(v-else)

</template>

<script>
import { db } from '@/firebase'
import { send, blast, cancelCountdown, getCountdown, recordDataLog } from '@/api'
import { Carousel, Slide } from 'vue-carousel'

const videoRef = db.ref('videoCalling')

export default {
  name: 'dashboard',
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      usersCount: 0,
      name: null,
      loading: true,
      profPicUrl: 'static/img/avatars/0.png',
      pageID: this.$route.params.userId,
      chats: [],
      msg: {
        content: '',
      },
      paused: false,
      onlineStatus: 'danger',
      sending: false,
      avatarURL: null,
      countdown: 999,
      dTimer: null,
      flagged: false,
      currentUser: this.$store.state.profile.firstName, // agent profile
      duplicateAgent: false,
      newestKey: null,
      flagKey: null,
      firstSendObj: {},
      firstNameOfAgent: this.$store.state.profile.firstName,
      uniqueIDOfAgent: this.$store.state.profile.uniqueID,
      cdSync: false,
      noOfChats: 1,
      firstChatID: '',
      clickedOnLoadMore: false,
      maxChatsNotReached: true,
      loadingMore: false,
      pc: null,
      screenFull: true,
      videoIsOn: false,
      videoIsMute: false,
      videoStream: null,
      noteText: '',
      micIsMute: false,
    }
  },
  mounted: function() {
  },
  beforeDestroy: function() {
    // this condition is to prevent the clock from showing in the ui after 300 seconds is over
    // it happens when the agent stays in the page after sending a message.
    if (this.flagged) {
      getCountdown(this.pageID, this.flagKey)
        .then((jsonObj) => {
          // check if the timeleft is zero or less
          const timeLeft = jsonObj.body
          if (jsonObj.statusCode !== 400 && timeLeft <= 0) {
            this.flagged = false
            delete this.firstSendObj[this.pageID]
            localStorage.setItem('firstSendObj', JSON.stringify(this.firstSendObj))
          }
        })
    }
    clearInterval(this.dTimer)
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      /* if (window.pageYOffset == 0 && this.maxChatsNotReached == true) {
        this.addNoOfChats()
      } */
    },
    // toggleFullscreen: function() {
    //   this.screenFull = !this.screenFull
    // },
    replaceNewline: function(innerHTML) {
      if (typeof innerHTML !== 'string') {
        return ''
      }
      return innerHTML.replace(/\n/g, '<br>')
    },
    addNoOfChats() {
      this.loadingMore = true
      this.noOfChats += 1
      this.clickedOnLoadMore = true
      this.displayChat(this.noOfChats)
    },
    triggersend(evt) {
      evt.preventDefault()
      this.$refs.myModalRef.hide()
      this.Sendconfirmation = true
    },
    hidemodal() {
      this.$refs.myModalRef.hide()
      this.Sendconfirmation = false
    },
    navigation() {
      this.$router.push('/interactionsRT')
      this.$snotify.error('Your page session has expired!')
    },
    sendMessage() {
      this.sending = true
      // const self = this
      var content = {
        platform: 'webPopup',
        userID: this.pageID,
        message: this.msg.content,
        // send details about agent (sendMsgByAgent)
        agentName: this.firstNameOfAgent,
        agentID: this.uniqueIDOfAgent,
      }
      // console.log(content)
      // var content
      send(content)
        .then(function (res) {
          res.error && this.$snotify.error(res.error)
          if (this.flagged && this.firstSendObj[this.pageID] && this.msg.content !== undefined && /^\s*$/.test(this.msg.content)) {
            this.firstSendObj[this.pageID] = false
            window.localStorage.setItem('firstSendObj', JSON.stringify(this.firstSendObj))
            // TODO:
            // validate that the requests went through
            cancelCountdown(this.pageID).then(function (res) { console.log(res) })
          }
          // if (this.flagged) {
          //   resetFlagTime(this.pageID, this.flagKey).then(function (res) {
          //     console.log('cd reset', res)
          //     self.cdSync = false
          //     getCountdown(self.pageID, self.flagKey)
          //       .then((jsonObj) => {
          //         // Extend the timeleft to server time
          //         const timeLeft = jsonObj.body
          //         if (jsonObj.statusCode !== 400 && timeLeft !== 0) {
          //           self.countdown = timeLeft
          //           self.cdSync = true
          //         }
          //       })
          //   })
          // }
          this.sending = false
        }.bind(this))
      // handleFlaggedMessage(this.pageID, this.firstNameOfAgent)
      recordDataLog('sendMessage', `${this.pageID}/${this.$store.state.profile.uniqueID}`, {
        message: content.message,
      })
      this.$data.msg.content = ''
      document.getElementsByTagName('input')[0].value = ''
    },
    sendBlast() {
      var content = {
        platform: 'webPopup',
        campaignGroup: 'demo',
        campaign: this.msg.content,
      }
      // var content
      blast(content)
        .then(function (res) {
          res.error && this.$snotify.error(res.error)
        })
    },
    // video calling function
    initializeVideocall() {
      var that = this
      process.nextTick(function() {
        // var yourVideo = document.getElementById('yourVideo')
        var friendsVideo = document.getElementById('friendsVideo')
        var yourId = Math.floor(Math.random() * 1000000000)
        that.$data.videoId = yourId
        // Create an account on Viagenie (http://numb.viagenie.ca/), and replace {'urls': 'turn:numb.viagenie.ca','credential': 'websitebeaver','username': 'websitebeaver@email.com'} with the information from your account
        var servers = { 'iceServers': [{ 'urls': 'stun:stun.services.mozilla.com' }, { 'urls': 'stun:stun.l.google.com:19302' }, { 'urls': 'turn:numb.viagenie.ca', 'credential': 'beaver', 'username': 'boringdragonlee@gmail.com' }] }
        var pc = new RTCPeerConnection(servers)
        that.$data.pc = pc
        pc.onicecandidate = event => event.candidate ? sendMessage(yourId, JSON.stringify({ 'ice': event.candidate })) : console.log('Sent All Ice')
        pc.onaddstream = event => { friendsVideo.srcObject = event.stream }
        pc.oniceconnectionstatechange = function() {
          if (pc.iceConnectionState == 'disconnected') {
            that.closeVideo()
          }
        }
        videoRef.on('child_added', readMessage)
        that.setStart()
        that.showMyFace()
      })

      function sendMessage(senderId, data) {
        var msg = videoRef.push({ sender: senderId, message: data })
        msg.remove()
      }

      function readMessage(data) {
        var msg = JSON.parse(data.val().message)
        var sender = data.val().sender
        if (sender != that.$data.videoId) {
          if (msg.ice != undefined) {
            that.$data.pc.addIceCandidate(new RTCIceCandidate(msg.ice))
          } else if (msg.sdp.type == 'offer') {
            that.$data.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp))
              .then(() => that.$data.pc.createAnswer())
              .then(answer => {
                that.$data.answer = answer
                document.getElementById('acceptCallButton').style.display = ''
                document.getElementById('rejectCallButton').style.display = ''
              })
          } else if (msg.sdp.type == 'answer') {
            that.$data.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp))
          }
        }
      }
    },
    showMyFace() {
      var yourVideo = document.getElementById('yourVideo')
      yourVideo.muted = 'muted'
      navigator.mediaDevices.getUserMedia({ audio: true, video: true })
        .then((stream) => {
          yourVideo.srcObject = stream
          this.$data.videoStream = stream
          return stream
        })
        .then(stream => {
          this.$data.pc.addStream(stream)
        })
    },
    setStart() {
      document.getElementById('alertClient').style.display = ''
      document.getElementById('alertStart').style.display = 'none'
      document.getElementById('closeVideoButton').style.display = 'none'
    },
    setOnCalling() {
      document.getElementById('alertClient').style.display = 'none'
      document.getElementById('muteMicButton').style.display = ''
      document.getElementById('muteVideoButton').style.display = ''
      document.getElementById('closeVideoButton').style.display = ''
    },
    closeOnCalling() {
      document.getElementById('alertStart').style.display = ''
      document.getElementById('alertClient').style.display = 'none'
      document.getElementById('muteMicButton').style.display = 'none'
      document.getElementById('muteVideoButton').style.display = 'none'
      document.getElementById('closeVideoButton').style.display = 'none'
    },
    acceptOnCalling() {
      document.getElementById('alertClient').style.display = 'none'
      document.getElementById('muteMicButton').style.display = ''
      document.getElementById('muteVideoButton').style.display = ''
      document.getElementById('closeVideoButton').style.display = ''
    },
    acceptCall() {
      document.getElementById('acceptCallButton').style.display = 'none'
      document.getElementById('rejectCallButton').style.display = 'none'
      this.acceptOnCalling()
      this.$data.pc.setLocalDescription(this.$data.answer)
        .then(() => sendMessage(this.$data.videoId, JSON.stringify({ 'sdp': this.$data.pc.localDescription })))

      function sendMessage(senderId, data) {
        var msg = videoRef.push({ sender: senderId, message: data })
        msg.remove()
      }
    },
    rejectCall() {
      document.getElementById('acceptCallButton').style.display = 'none'
      document.getElementById('rejectCallButton').style.display = 'none'
      alert('Call Rejected.')
    },
    muteMic() {
      var yourVideo = document.getElementById('yourVideo')
      this.$data.micIsMute = yourVideo.srcObject.getAudioTracks()[0].enabled
      if (yourVideo.srcObject.getAudioTracks()[0].enabled == true) {
        document.getElementById('muteMicButton').classList.add('btn-danger')
        document.getElementById('muteMicButton').classList.remove('btn-primary')
        yourVideo.srcObject.getAudioTracks()[0].enabled = false
      } else {
        document.getElementById('muteMicButton').classList.add('btn-primary')
        document.getElementById('muteMicButton').classList.remove('btn-danger')
        yourVideo.srcObject.getAudioTracks()[0].enabled = true
      }
    },
    muteVideo() {
      try {
        var yourVideo = document.getElementById('yourVideo')
        if (this.$data.videoIsMute == false) {
          document.getElementById('muteVideoButton').classList.add('btn-danger')
          document.getElementById('muteVideoButton').classList.remove('btn-primary')
          yourVideo.srcObject.getVideoTracks()[0].enabled = false
          this.$data.videoIsMute = true
        } else {
          document.getElementById('muteVideoButton').classList.add('btn-primary')
          document.getElementById('muteVideoButton').classList.remove('btn-danger')
          yourVideo.srcObject.getVideoTracks()[0].enabled = true
          this.$data.videoIsMute = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    closeVideo() {
      try {
        // reset mute video
        if (this.$data.videoIsMute == true) {
          this.muteVideo()
        }
        var yourVideo = document.getElementById('yourVideo')
        if (yourVideo.srcObject.getAudioTracks()[0].enabled == false) {
          this.muteMic()
        }
        yourVideo.srcObject = null
        var friendsVideo = document.getElementById('friendsVideo')
        friendsVideo.srcObject = null
        this.closeOnCalling()
        this.setclose()
        this.$data.pc.close()
        this.$data.pc = null
      } catch (error) {
        console.log(error)
      }
    },
    showFriendsFace() {
      this.setOnCalling()
      this.$data.pc.createOffer()
        .then(offer => this.$data.pc.setLocalDescription(offer))
        .then(() => sendMessage(this.$data.videoId, JSON.stringify({ 'sdp': this.$data.pc.localDescription })))

      function sendMessage(senderId, data) {
        var msg = videoRef.push({ sender: senderId, message: data })
        msg.remove()
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/VideoCall.vue?6e23e7d0